import React, { useState, useEffect } from 'react'
import { useHistory, Link } from 'react-router-dom'
import * as yup from 'yup'
// import axios from 'axios'
import { axiosWithAuth } from './axiosWithAuth'
import styled from 'styled-components'


const StyledLogin = styled.div`

    h4 {
        color: #138CFE;
    }

    form {
        display: flex;
        flex-direction: column;
        align-items: center;
    }

    #login {
        margin: 1% 0;
        box-shadow:inset 0px 1px 0px 0px #bee2f9;
        background:linear-gradient(to bottom, #63b8ee 5%, #468ccf 100%);
        background-color:#63b8ee;
        border-radius:6px;
        border:1px solid #3866a3;
        display:inline-block;
        cursor:pointer;
        color:#14396a;
        font-family:Arial;
        font-size:15px;
        font-weight:bold;
        padding:6px 24px;
        text-decoration:none;
        text-shadow:0px 1px 0px #7cacde;
    }

    #login:hover {
        background:linear-gradient(to bottom, #468ccf 5%, #63b8ee 100%);
	    background-color:#468ccf;
    }

    #sign-up {
        margin-bottom: 1%;
        box-shadow:inset 0px 1px 0px 0px #ffffff;
        background:linear-gradient(to bottom, #ffffff 5%, #f6f6f6 100%);
        background-color:#ffffff;
        border-radius:6px;
        border:1px solid #dcdcdc;
        display:inline-block;
        cursor:pointer;
        color:#666666;
        font-family:Arial;
        font-size:15px;
        font-weight:bold;
        padding:6px 24px;
        text-decoration:none;
        text-shadow:0px 1px 0px #ffffff;
    }

    #sign-up:hover {
        background:linear-gradient(to bottom, #f6f6f6 5%, #ffffff 100%);
	    background-color:#f6f6f6;
    }

`


const schema = yup.object().shape({
    name: yup.string().required('You must enter a name.'),
    email: yup.string().required('You must enter an email.'),
    password: yup.string().required(`A valid password is required.`)
})


const initialFormValues = {
    name: '',
    email: '',
    password: ''
  }

export default function Login() {

    // const [ user, setUser ] = useState(initialFormValues)
    const [ formValues, setFormValues ] = useState(initialFormValues)
    const [ formErrors, setFormErrors ] = useState(initialFormValues)
    const history = useHistory()

    const onChange = (evt) => {
        const { name, value } = evt.target;
        yup
            .reach(schema, name)
            .validate(value)
            .then(() => setFormErrors({...formErrors, [name]:''}))
            .catch((err) => {
            setFormErrors({...formErrors, [name]:err.errors[0]})
        })
        setFormValues({...formValues, [name]: value})
    }

    const onSubmit = (evt) => {
        evt.preventDefault();
        const member = {
            name: formValues.name.trim(),
            password: formValues.password.trim(),
          };
          if (!member.name || !member.password) {
            return;
          }
          setFormValues(initialFormValues);
          postUser(member);
        // axios
        //     .get('')
        //     .then((res) => {
        //         setUser({...user})
        //         history.push(`/home`)
        //     })
        //     postUser(member)
    }

    const postUser = (user) => {
        axiosWithAuth()
            .post('/auth/login', user)
            .then((res) => {
                console.log(res)
                localStorage.setItem('token', res.data.token)
                history.push('/home')
                return res
            })
            // .then((res) => {
            //     localStorage.setItem('user_id', res.data)
            // })
            .catch((error) => {
                console.error('Server Error', error)
            })
    }

    // useEffect(() => {
    //     schema.isValid(formValues).then((valid) => {
    //         setdisb(!valid)
    //     })
    // })
    return(
        <StyledLogin>
            <div>
                <div> {formErrors.name} </div>
                <div> {formErrors.email} </div>
                <div> {formErrors.password} </div>
            </div>
            <form onSubmit={onSubmit}>
                <label> <h4> Name:</h4>
                    <input
                    type='text'
                    name='name'
                    placeholder='Name'
                    value={formValues.name}
                    onChange={onChange}
                    >
                    </input>
                </label>
                <label> <h4>Email:</h4>
                    <input
                    type='email'
                    name='email'
                    placeholder='Email'
                    value={formValues.email}
                    onChange={onChange}
                    >
                    </input>
                </label>
                <label> <h4>Password:</h4>
                    <input
                    type='password'
                    name='password'
                    placeholder='Password'
                    value={formValues.password}
                    onChange={onChange}
                    >
                    </input>
                </label>
                <button
                type='submit'
                id='login'
                > Login </button>
            </form>
            <Link to='/sign-up'>
                <button id='sign-up'>Account non existent? Sign up here!</button>
            </Link>
        </StyledLogin>
    )
}




